/**
 * PDF.js Configuration
 * Configures the PDF.js worker for PDF parsing and rendering
 */
import { pdfjs } from 'react-pdf';

const isMobileBrowser = typeof navigator !== 'undefined'
  && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');

// Configure PDF.js worker
if (typeof window !== 'undefined') {
  // Keep the worker local so we control compatibility consistently.
  pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

  console.log('📄 PDF.js worker configured:', {
    version: pdfjs.version || '5.4.296',
    workerSrc: pdfjs.GlobalWorkerOptions.workerSrc,
    isMobile: isMobileBrowser
  });
}

export const PDF_RUNTIME_FLAGS = isMobileBrowser
  ? {
      // Conservative path for mobile devices (iOS/Android) to avoid memory-related worker termination
      useWorkerFetch: false,
      useWasm: false,
      isImageDecoderSupported: false,
      isOffscreenCanvasSupported: false,
      isEvalSupported: false,
      // 16MB was causing visible downsampling on high-DPI phones/tablets.
      canvasMaxAreaInBytes: 48 * 1024 * 1024,
    }
  : {
      useWorkerFetch: true,
      useWasm: true,
      isImageDecoderSupported: true,
      isOffscreenCanvasSupported: true,
      isEvalSupported: true,
    };


export const PDF_CONFIG = {
  // PDF rendering options
  scale: 1.2, // Optimized for rendering speed while maintaining legibility
  renderTextLayer: true, // Enable text selection
  renderAnnotationLayer: true, // Enable annotations
  // Use version-matched jsDelivr for CMaps
  cMapUrl: `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version || '5.4.296'}/cmaps/`,
  cMapPacked: true,
};
